//广告组状态
const adGroupStatus = [
  { value: -1, label: "全部状态" },
  { value: "1", label: "计划已暂停" },
  { value: "3", label: "计划超预算" },
  { value: "6", label: "余额不足" },
  { value: "10", label: "已删除" },
  { value: "11", label: "审核中" },
  { value: "12", label: "审核未通过" },
  { value: "14", label: "已结束" },
  { value: "15", label: "已暂停" },
  { value: "17", label: "组超预算" },
  { value: "19", label: "未达投放时间" },
  { value: "20", label: "有效" },
];

const filterStatus = [
  { value: "AD_STATUS_NORMAL", label: "有效" },
  { value: "AD_STATUS_PENDING", label: "待审核" },
  { value: "AD_STATUS_DENIED", label: "审核不通过" },
  { value: "AD_STATUS_PARTIALLY_PENDING", label: "部分审核中" },
  { value: "AD_STATUS_PARTIALLY_NORMAL", label: "部分有效" },
  { value: "AD_STATUS_PREPARE", label: "准备中（当投放视频广告时，该状态代表视频转码中）" },
  { value: "AD_STATUS_DELETED", label: "已删除" },
  { value: "AD_STATUS_INVALID", label: "异常（当投放视频广告时，该状态代表视频转码失败）" },
  { value: "AD_STATUS_SUSPEND", label: "暂停" },
];

const placeList = [
  { value: "1", label: "优选广告位" },
  { value: "5", label: "联盟广告" },
  { value: "6", label: "上下滑大屏广告" },
  { value: "24", label: "激励视频" },
];

export default {
  adGroupStatus,
  placeList,
  filterStatus,
};
